import axios from "@/assets/js/api";

export default {
  data() {
    return {
      rooms: [],
    searchQuery: "",
    currentPage: 1,
    itemsPerPage: 10,
    activeButton: "all",
    showEditModal: false,
    editRoomData: {
      id: "",
      roomNumber: "",
      roomTypeName: "",
      isAvailable: "",
      isCleaned: "",
      notes: "",
      },
    };
  },
  computed: {
    filteredRooms() {
      let result = this.rooms;
      
      // 根據當前選擇的按鈕進行篩選
      if (this.activeButton === 'checkIn') {
        result = result.filter(room => !room.isAvailable);
      } else if (this.activeButton === 'checkOut') {
        result = result.filter(room => room.isAvailable);
      }
      
      // 根據搜尋關鍵字篩選房號
      const query = this.searchQuery.trim().toLowerCase();
      if (query) {
        result = result.filter(room => 
          room.roomNumber.toString().toLowerCase().includes(query)
        );
      }
      
      return result;
    },
    totalPages() {
      return Math.ceil(this.filteredRooms.length / this.itemsPerPage);
    },
    paginatedRooms() {
      const startIndex = (this.currentPage - 1) * this.itemsPerPage;
      return this.filteredRooms.slice(
        startIndex,
        startIndex + this.itemsPerPage
      );
    },
    hasNextPage() {
      return this.currentPage < this.totalPages;
    },
    hasPreviousPage() {
      return this.currentPage > 1;
    },
  },
  methods: {
    //讀取資料庫所有房型資料
    async fetchRooms() {
      try {
        const response = await axios.get("/Rooms");
        this.rooms = response.data; // 直接使用返回的數據，因為屬性名稱已經正確
        
      } catch (error) {
        console.error("無法取得房間資料", error);
      }
    },
    
    // 設定按鈕的選中狀態並執行篩選邏輯
    setActiveButton(buttonName) {
      this.activeButton = buttonName;
      this.currentPage = 1; // 重置頁碼到第一頁
    },

    editRoom(roomNumber) {
      const room = this.rooms.find((r) => r.roomNumber === roomNumber);
      if (room) {
        console.log("要編輯的原始房間數據:", room);
        this.editRoomData = { ...room };
        console.log("設置到編輯表單的數據:", this.editRoomData);
        this.showEditModal = true;
      }
    },
    async saveEdit() {
      try {
        const updatedRoom = { ...this.editRoomData };
        console.log("準備發送到後端的數據:", updatedRoom);

        // 確保數據格式符合後端要求
        const requestData = {
          id: updatedRoom.id,
          roomNumber: updatedRoom.roomNumber,
          roomTypeName: updatedRoom.roomTypeName,
          isAvailable: Boolean(updatedRoom.isAvailable),
          isCleaned: Boolean(updatedRoom.isCleaned),
          notes: updatedRoom.notes || " ",
        };

        console.log("格式化後的請求數據:", requestData);

        const response = await axios.put(
          `/Rooms/${updatedRoom.id}`,
          requestData
        );
        console.log("後端響應:", response);

        this.fetchRooms();
        this.showEditModal = false;
      } catch (error) {
        console.error("更新房間失敗", error);
        if (error.response) {
          console.log("錯誤響應數據:", error.response.data);
          console.log("錯誤狀態:", error.response.status);
          console.log("錯誤標頭:", error.response.headers);
          console.log("具體驗證錯誤:", error.response.data.errors);
        }
      }
    },
    closeEditModal() {
      this.showEditModal = false;
    },
    // 分頁操作
    prevPage() {
      if (this.hasPreviousPage) this.currentPage--;
    },
    nextPage() {
      if (this.hasNextPage) this.currentPage++;
    },
    goToPage(page) {
      if (page >= 1 && page <= this.totalPages) {
        this.currentPage = page;
      }
    },
  },

  mounted() {
    this.fetchRooms();
  },
};
